export { default } from './H1';



// WEBPACK FOOTER //
// ./src/components/H1/index.js